// -- Set products --
// A product with Set KG switched on (isKgSet) is sold by the set, and one set
// is always 6 pieces (rolls) - its KG is the weight of the whole set, e.g.
// 150 KG = 6 x ~25 KG. Kept in step with SET_PIECES in the backend
// (modules/app/helper/set-product.js).
export const SET_PIECES = 6;

export const isSetProduct = (product) => Boolean(product?.isKgSet);
